import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExpertReceipt } from 'src/app/models/expert-receipt.schema';
import { Expert } from 'src/app/models/expert.schema';
import { ExpertReceiptStatus, ExpertReceiptStatusAux } from 'src/app/models/refund-request.schema';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { ExpertReceiptsService } from 'src/app/services/expert-receipts.service';
import { ExpertService } from 'src/app/services/expert.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-valet-payment-receipts',
  templateUrl: './valet-payment-receipts.component.html',
  styleUrls: ['./valet-payment-receipts.component.scss']
})
export class ValetPaymentReceiptsComponent implements OnInit {

  activeAccordionActivityIndex: number | null = null;
  expertReceipts: any[] = [];
  disableBtn: boolean = false;
  expertReceiptStatus = ExpertReceiptStatus;
  expertReceiptStatusAux = ExpertReceiptStatusAux;
  filtered = {};
  paymentsFilterForm: any;
  selected = "active";
  defaultDeliveryOrder = { 'ExpertReceipts.id': 'DESC' };
  selectedExpertId: number;
  receiptStatus: string = null;
  selectedValet: Expert;
  experts: Expert[] = [];
  groups: any;
  
  constructor(
    private expertReceiptsService: ExpertReceiptsService,
    private commanUsesService: CommanUsesService,
    private route: ActivatedRoute,
    private spinnerService: SpinnerService,
    private expertService: ExpertService,
    private router: Router,
    private authStatusService: AuthStatusService,
  ) { 
    this.selected = !this.route.snapshot.data['active'] ? 'inactive' : 'active';
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
  }

  async ngOnInit() {
    const loggedInUserInfo = await this.authStatusService.getTokenInfo();

    if (this.groups.includes('expert')) {
      this.selectedValet = await this.expertService.getOne(loggedInUserInfo['extraId']);
      this.selectedExpertId = this.selectedValet?.id;

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { expertId: this.selectedExpertId },
        queryParamsHandling: 'merge',
      });

      await this.initFilter();
      await this.getAllExpertReceipt();

    } else if (this.groups.includes('admin') || this.groups.includes('operation')) {
      await this.getExperts();

      this.route.queryParams.subscribe(async (params) => {
        if (params['expertId']) {
          this.selectedExpertId = +params['expertId'];
          this.selectedValet = this.experts.find(v => v.id === this.selectedExpertId);
        }

        await this.initFilter();
        await this.getAllExpertReceipt();
      });
    }
  }



  async initFilter() {
    this.filtered = {};
    this.filtered['ExpertReceipts.expertId'] = this.selectedExpertId;

    if (this.receiptStatus) {
      this.filtered['ExpertReceipts.receiptStatus'] = {
        operator: 'like',
        values: [`%${this.receiptStatus}%`],
      };
    } else {
      const availableStatuses = this.selected === 'active'
        ? ExpertReceiptStatusAux.active
        : ExpertReceiptStatusAux.inactive;

      this.filtered['ExpertReceipts.receiptStatus'] = {
        operator: 'in',
        values: availableStatuses,
      };
    }
  }

  async getAllExpertReceipt(){
    try {
      if(this.selectedExpertId) {
        this.expertReceipts = await this.expertReceiptsService.getAllExpertReceipts(1, 1000, this.defaultDeliveryOrder, this.filtered);
      }
    } catch (error) { }
  }

  async handleValetChange(valetId: number) {
    try {
      this.spinnerService.show();
      this.selectedValet = this.experts.find(v => v.id === Number(valetId));
      this.selectedExpertId = this.selectedValet?.id;
      await this.initFilter();

      this.router.navigate([], {
        queryParams: { expertId: this.selectedExpertId },
        queryParamsHandling: 'merge'
      });

      await this.getAllExpertReceipt();
      this.spinnerService.hide();
    } catch (error) {
      console.error("ERROR", error);
    }
  }

  async handleStatusDropdown() {
    this.spinnerService.show();
    await this.initFilter();
    await this.getAllExpertReceipt();
    this.spinnerService.hide();
  }

  toggleAccordion(index?: number){
    if (this.activeAccordionActivityIndex === index) {
      this.activeAccordionActivityIndex = null;
    } else {
      this.activeAccordionActivityIndex = index; 
    }
  }

  openReceiptInNewTab(url: string) {
    window.open(url, '_blank');
  }
  
  async getExperts(){
    this.experts = await this.expertService.getAllActiveExpertsForDelivery().then(res => res.experts);
  }

  async handleApproveClick(expertReceipt: ExpertReceipt, event: MouseEvent) {
    try {
      event.stopPropagation();
      if (!confirm("Are you sure? Receipt will be approved")) return;

      this.disableBtn = true;
      let promise = this.expertReceiptsService.approveReceipt(expertReceipt.id);

      promise.then(async (response: ExpertReceipt) => {
        this.disableBtn = false;
        if(response.id) {
          this.commanUsesService.showSnackBar('Receipt has been approved');
        }
        await this.getAllExpertReceipt();
      }).catch((error) => {
        this.disableBtn = false;
        this.commanUsesService.showSnackBar(`${error?.error?.message}`);
      });
      
    } catch (error) {
      this.disableBtn = false;
      this.commanUsesService.showSnackBar(`${error?.error?.message}`);
    }
  }

  async handlePaidClick(expertReceipt: ExpertReceipt, event: MouseEvent){
    try {
      event.stopPropagation();
      
      if (!confirm("Are you sure? This will set as paid.")) return;

      this.disableBtn = true;
      let promise = this.expertReceiptsService.paidReceipt(expertReceipt.id);

      promise.then(async (response: ExpertReceipt) => {
        this.disableBtn = false;
        if(response.id) {
          this.commanUsesService.showSnackBar('Receipt has been set as paid.');
        }
        await this.getAllExpertReceipt();
      }).catch((error) => {
        this.disableBtn = false;
        this.commanUsesService.showSnackBar(`${error?.error?.message}`);
      });

    } catch (error) {
      this.disableBtn = false;
      this.commanUsesService.showSnackBar(`${error?.error?.message}`);
    }
  }

  handleReceiptUpload(event: Event, expertReceipt: ExpertReceipt) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      if (file.type !== 'application/pdf') {
        this.commanUsesService.showSnackBar('Please upload a valid PDF file.');
        input.value = ''; 
        return;
      }

      const formData = new FormData();
      formData.append('receipt', file);

      let promise = this.expertReceiptsService.uploadReceipt(expertReceipt.id, formData);
      promise.then(async (res: ExpertReceipt)=> {
        if(res){
          this.disableBtn = false;
          this.commanUsesService.showSnackBar('Receipt has been uploaded');
          await this.getAllExpertReceipt();
        }
      }).catch((err: any)=> {
        let errorMsg = '';
        errorMsg = err.error.message;
        this.commanUsesService.showSnackBar(errorMsg);
        this.disableBtn = false;
      })
    }
  }

}
